module.exports = __webpack_public_path__ + "img/icon-kokomi.12e9417f.webp";